export const MODAL_TRANSITION_DURATION = 250; // ms
export const MODAL_DEFAULT_WIDTH = 430;
